<template>
  <SearchCategory
    :key="slug"
    :category-slug="slug"
  />
</template>

<script lang='ts'>
import SearchCategory from '~/components/pages/SearchCategory.vue';
definePageMeta({
  layout: 'default-full-width',
  middleware: [
    'native-route-redirection',
    'check-search-params',
    'first-page-redirection',
    'typesense-sort-by-redirection',
  ],
});


export default defineComponent({
  name: 'CategorySlug',
  components: {
    SearchCategory,
  },
  setup () {

    const route = useRoute();
    const slug = computed(() => route.params?.slug);

    return {
      slug,
    };
  
  },
});

</script>
